import React from "react";
import { Switch, Redirect } from "react-router-dom";
//import LoanPayment from "../containers/ReportsContainer/LoanPayment";
import {
  ContributionLimit,
  DeletedParticipant,
  RehireReport,
  NewParticipant,
  EligibilityReports,
  EligibiltyForecast,
  EmploymentStatus,
  GContributionLimit,
  ErrorCount,
  SponsorDetails,
  PlanSummary,
  ParticipantContributionDataReports,
  ParticipantUpdatesReport,
  CompensationHoursLoansReport,
  ContributionFlagsReport,
  LoanPayment,
  LoanPaymentReports,
  PlanEligibilityDataReport,
  LatePayrollNotifications,
  PeriodicCensus,
  PeriodicMatch,
  RMDReport,
  ForceOutReport,
  AggregatedReport,
  PayrollWorkloadAnticipation,
  PlanList,
  MissedRMDReport,
  EnrollmentReview,
  Report316,
  PayrollCalendarEnddate,
  MapperList,
} from "../layouts";
import ForfeitureReport from "../layouts/ManageReport/ForfeitureReport";
import ParticipantStatusChange from "../layouts/ManageReport/ParticipantStatusChange";
import VestingReductionReport from "../layouts/ManageReport/VestingReductionReport";
import LoanRepaymentDetailReport from "../layouts/ManageReport/LoanRepaymentDetailReport/LoanRepaymentDetailReport";

import { ROUTES, MANAGE_REPORTS_ROUTES, ApplicationRoute } from "../utils";
import NonPayPeriodReport from "../containers/ReportsContainer/NonPayPeriodReport/NonPayPeriodReport";
import PayrollFrequencyReport from "../containers/ReportsContainer/PayrollFrequencyReport/PayrollFrequencyReport";

const menu = "reports",
  flow = "edit";
export const ManageReportRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER}/:flow(edit)/:reportId?`,
        ]}
        component={EligibilityReports}
      />

      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PAYROLL_CALENDAR_ENDDATE}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PAYROLL_CALENDAR_ENDDATE}/.flow(edit)/:reportId?`,
        ]}
        component={PayrollCalendarEnddate}
      />

      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.FORFEITURE_REPORTS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.FORFEITURE_REPORTS}/:flow(edit)/:reportId?`,
        ]}
        component={ForfeitureReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PARTICIPANT_STATUS_CHANGE_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PARTICIPANT_STATUS_CHANGE_REPORT}/:flow(edit)/:reportId?`,
        ]}
        component={ParticipantStatusChange}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.VESTING_REDUCTION_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.VESTING_REDUCTION_REPORT}/:flow(edit)/:reportId?`,
        ]}
        component={VestingReductionReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.GCONTRIBUTION_LIMITS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.GCONTRIBUTION_LIMITS}/:flow(edit)/:reportId?`,
        ]}
        component={GContributionLimit}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.LOAN_REPAYMENT_DETAIL_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.LOAN_REPAYMENT_DETAIL_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={LoanRepaymentDetailReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.ELIGIBILITY_FORECAST}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.ELIGIBILITY_FORECAST}/:flow(edit)/:reportId?`,
        ]}
        component={EligibiltyForecast}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.CONTRIBUTION_LIMITS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.CONTRIBUTION_LIMITS}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={ContributionLimit}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.DELETED_PARTICIPANT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.DELETED_PARTICIPANT}/:flow(edit)/:reportId?`,
        ]}
        component={DeletedParticipant}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.REHIRE_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.REHIRE_REPORT}/:flow(edit)/:reportId?`,
        ]}
        component={RehireReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.NEW_PARTICIPANT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.NEW_PARTICIPANT}/:flow(edit)/:reportId?`,
        ]}
        component={NewParticipant}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.EMPLOYEMENT_STATUS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.EMPLOYEMENT_STATUS}/:flow(edit)/:reportId?`,
        ]}
        component={EmploymentStatus}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.ERROR_COUNT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.ERROR_COUNT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={ErrorCount}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.LATE_PAYROLL_NOTIFICATIONS}/:reportId?`,

          `${MANAGE_REPORTS_ROUTES.LATE_PAYROLL_NOTIFICATIONS}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={LatePayrollNotifications}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.SPONSOR_DETAILS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.SPONSOR_DETAILS}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={SponsorDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PLAN_SUMMARY}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PLAN_SUMMARY}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={PlanSummary}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.CONTRIBUTION_DATA_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.CONTRIBUTION_DATA_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={ParticipantContributionDataReports}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PARTICIPANT_UPDATES_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PARTICIPANT_UPDATES_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={ParticipantUpdatesReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.COMPENSATION_HOURS_AND_LOANS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.COMPENSATION_HOURS_AND_LOANS}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={CompensationHoursLoansReport}
      />

      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.LOAN_PAYMENT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.LOAN_PAYMENT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={LoanPayment}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.CONTRIBUTION_FLAGS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.CONTRIBUTION_FLAGS}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={ContributionFlagsReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PLAN_ELIGIBILITY_DATA_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PLAN_ELIGIBILITY_DATA_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={PlanEligibilityDataReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PERIODIC_CENSUS}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PERIODIC_CENSUS}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={PeriodicCensus}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PERIODIC_EMPLOYER_CONTRIBUTION_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PERIODIC_EMPLOYER_CONTRIBUTION_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={PeriodicMatch}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.AGGREGATED_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.AGGREGATED_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={AggregatedReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.RMD_Report}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.RMD_Report}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={RMDReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.MISSED_RMD_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.MISSED_RMD_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={MissedRMDReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.FORCE_OUT_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.FORCE_OUT_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={ForceOutReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PAYROLL_WORKLOAD_ANTICIPATION_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PAYROLL_WORKLOAD_ANTICIPATION_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={PayrollWorkloadAnticipation}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PLAN_LIST_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PLAN_LIST_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={PlanList}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_REPORTS_ROUTES.ENROLLMENT_REVIEW_REPORT}
        component={EnrollmentReview}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_REPORTS_ROUTES.REPORT_316}
        component={Report316}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_REPORTS_ROUTES.NON_PAY_PERIOD_REPORT}
        component={NonPayPeriodReport}
      />
      <Redirect
        exact
        menu={menu}
        flow={flow}
        from={ROUTES.MANAGE_REPORTS}
        to={MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.MAPPER_LIST_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.MAPPER_LIST_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={MapperList}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_REPORTS_ROUTES.PAYROLL_FREQUENCY_REPORT}/:reportId?`,
          `${MANAGE_REPORTS_ROUTES.PAYROLL_FREQUENCY_REPORT}/:flow(add|edit|save)/:reportId?`,
        ]}
        component={PayrollFrequencyReport}
      />
      <Redirect to={ROUTES.HOME} />
    </Switch>
  );
};
